function elementWrapper( selectorString, wrapperClassName = "element-wrapper", tagName = "div" ) {
    if ( !selectorString ) { return; }
    const targets = [... document.querySelectorAll( selectorString )];
    if ( !targets ) { return; }
    targets.forEach( element => {
        const wrapper = document.createElement( tagName );
        wrapper.classList.add( wrapperClassName );
        element.replaceWith( wrapper );
        wrapper.appendChild( element );
    } );
}

export { elementWrapper };
